<template>
    <div>
        <div v-if="enterpriseName && !isEnterpriseUser"
             class="alert alert-info alert-dismissible"
             :style="{ backgroundColor: sidebarColor }"
        >
            <h5>
                <span>
                    <i class="icon fas fa-info"></i>
                    <span v-text="`Espace ${ enterpriseName }`"></span>
                </span>
                <span>
                    <a @click="changeEnterprise">Changer d'entreprise</a>
                </span>
            </h5>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import permissionManager from "@/service/manager/permissionManager";

export default {
    computed: {
        ...mapGetters({
            enterpriseName: 'enterpriseName',
            sidebarColor: 'sidebarColor',
            role: 'role',
        }),
        isEnterpriseUser() {
            return this.role ? permissionManager.isEnterpriseUser(this.role) : false;
        },
    },
    methods: {
        ...mapActions({
            clearEnterpriseData: 'clearEnterpriseData'
        }),
        changeEnterprise() {
            this.clearEnterpriseData();
            this.$router.push({ name: 'enterprise-list' });
        }
    }
}
</script>

<style scoped lang="scss">
    h5 > span {
        display: block;
        margin-left: 0.4rem;
        font-size: 95%;

        &:not(:first-child) {
            margin-top: 0.2rem !important;
            margin-left: 1.5rem;
            font-size: 90%;
        }
    }

    a {
        cursor: pointer;
    }

    .alert {
        border-radius: 12px;
    }
</style>